import React from 'react';
import { useTranslation } from 'react-i18next';
import { CardGrid, Section, SignupCard } from 'common/components';
import { memo } from 'common/hocs/memo';
import { BATHROOM_CDN_PATH } from '../../old-bathroom-constants';
import { orderSectionCardGrid, orderSectionDesignSignupCard } from './order-section-styles';

type OrderSectionProps = {
  designRegistrationHref: string;
  elementText: string;
};

/**
 * Вью секции заказа
 */
export const OrderSection = memo(({ designRegistrationHref, elementText }: OrderSectionProps) => {
  const { t } = useTranslation();

  return (
    <Section>
      <CardGrid className={orderSectionCardGrid}>
        <SignupCard
          className={orderSectionDesignSignupCard}
          description={t('order-section.signup.description') || ''}
          buttonProps={{
            ariaLabel: t('order-section.signup.button-label'),
            elementBlock: 'landingVannuyuKomnatu',
            elementName: elementText,
            elementText: t('order-section.signup.button-name'),
            href: designRegistrationHref,
            label: t('order-section.signup.button-name'),
            target: '_blank',
            title: t('order-section.signup.button-label') || '',
          }}
          logo={{
            alt: t('order-section.signup.img-label'),
            src: `${BATHROOM_CDN_PATH}/order-buttons/1.png/1.png`,
          }}
          title={t('order-section.signup.title')}
        />

        <SignupCard
          description={t('order-section.inspiration.description') || ''}
          buttonProps={{
            ariaLabel: t('order-section.inspiration.button-label'),
            elementBlock: 'landingVannuyuKomnatu',
            elementName: t('order-section.inspiration.button-name'),
            elementText,
            href: '/uslugi/proektirovanie-i-dizayn/sozdayte-vannuyu-komnatu-svoey-mechty/stili/',
            label: t('order-section.inspiration.button-name'),
            title: t('order-section.inspiration.button-label') || '',
          }}
          logo={{
            alt: t('order-section.inspiration.img-alt'),
            src: `${BATHROOM_CDN_PATH}/order-buttons/2.png/2.png`,
          }}
          title={t('order-section.inspiration.title')}
        />
      </CardGrid>
    </Section>
  );
});
